<template>
  <div class="" v-if="items.length">
    <ul class="user_coins">
      <li v-for="item in items" :key="item.id" class="user_coin">
        <img src="storage/app/media/coin.svg" alt="">
        <span><strong> Выдан за даты:</strong> {{ item.date_from | formatDate }} - {{ item.date_to | formatDate }}</span>
        <span><strong> Качество д/з:</strong> {{ item.quality }}</span>
      </li>
    </ul>
  </div>
  <div v-else>Данные не найдены</div>
</template>

<script>
export default {
  name: "coin_stats",
  props: ['student_id'],
  inject: ['http'],
  data() {
    return {
      items: []
    }
  },  
  methods: {
    async init() {
      let data = {
        'user_id': this.student_id
      }
      this.items = await this.http.post('onGetUserCoins', data).then(res => res.data);
    }
  },
  mounted() {
    this.init();
  }
}
</script>